package com.devi3east.bashbuddy.features.route

sealed class BrowserRoute {
    object Home : BrowserRoute()
    object SignUp : BrowserRoute()
    object SignIn : BrowserRoute()
    object Leaderboard : BrowserRoute()
    object Cart : BrowserRoute()
    object TermsOfService: BrowserRoute()
    object PrivacyPolicy: BrowserRoute()
    object ContactUs: BrowserRoute()
    object Dashboard: BrowserRoute()
    object Profile: BrowserRoute()
    object Organization: BrowserRoute()
    object Favorites: BrowserRoute()
    object Search: BrowserRoute()
    data class TicketDetail(val ticketId: String): BrowserRoute()
    data class PrizeList(val eventId: String, val slug: String): BrowserRoute()
    data class EventDetail(val eventId: String, val slug: String) : BrowserRoute()
    data class StripeSuccess(
        val sessionId: String,
        val orgId: String
    ) : BrowserRoute()
}